import theme from '@/constants/theme';
import React from 'react';

export const styles: Record<string, React.CSSProperties> = {
  container: {
    display: 'flex',
    flex: 1,
    gap: 16,
    backgroundColor: theme.colors.background.primary,
    flexDirection: 'column',
    padding: '24px 16px',
    paddingBottom: 24,
  },
  title: {
    color: theme.colors.text.title,
  },
  text: {
    color: theme.colors.text.body,
  },
  pressableRoute: {
    flex: 1,
    marginTop: 4,
    marginBottom: 4,
  },
  cardsContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    marginBottom: 16,
  },
};
